import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

export default function Preloader({ done }) {
  const [pct, setPct] = useState(0);

  useEffect(() => {
    if (done) return;
    let raf;
    const start = performance.now();
    const tick = (t) => {
      const e = Math.min(1, (t - start) / 1400);
      setPct(Math.floor(e * 100));
      if (e < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [done]);

  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={{ opacity: done ? 0 : 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      style={{ pointerEvents: done ? "none" : "auto" }}
      className="fixed inset-0 z-[100] bg-black flex items-center justify-center"
      data-testid="preloader"
    >
      <div className="absolute inset-0 grain opacity-30" />
      <div className="relative text-center">
        <div className="font-display tracking-[0.4em] text-xs text-white/60 mb-6">
          SUE · PRODUCTION
        </div>
        <div className="font-display text-7xl md:text-8xl font-extralight text-gradient-silver tabular-nums">
          {pct.toString().padStart(2, "0")}
        </div>
        <div className="mt-8 mx-auto h-px w-40 bg-white/10 overflow-hidden">
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: `${pct}%` }}
            transition={{ ease: "linear", duration: 0.15 }}
            className="h-px bg-white"
          />
        </div>
      </div>
    </motion.div>
  );
}
